import React from 'react';
import ActiveAlarmList from '../../Alarm/ActiveAlarmList';
import T from '../../../localization/LocalizationKeys';
import Icons, { Size } from '../../Common/Icons';

/**
 * @returns {JSX.Element}
 */
const ActiveAlarmListPanel = () => {
  return <ActiveAlarmList />;
};

ActiveAlarmListPanel.info = {
  label: T.dashboard.panels.types.activealarms,
  icon: <Icons.Notification size={Size.LARGE}/>,
  help: 'panels/activealarmlist'
};

export default React.memo(ActiveAlarmListPanel);
